import { Component, EventEmitter, Input, Output, signal } from '@angular/core';
import { Message } from './message.interface';
import { IconComponent } from '../icon/icon.component';
import { MatButton } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { NgTemplateOutlet } from '@angular/common';
import { MessageTypeToIconPipe } from '../../pipes/message-type-to-icon.pipe';
import { MarkdownItPipe } from '../../pipes/markdown-it.pipe';

@Component({
    selector: 'ca-message',
    templateUrl: './message.component.html',
    styleUrls: ['./message.component.scss'],
    imports: [IconComponent, MatButton, RouterLink, NgTemplateOutlet, MessageTypeToIconPipe, MarkdownItPipe]
})
export class MessageComponent {
    closed = signal(false);

    @Input() public message: Message;

    @Output() public remove = new EventEmitter<Message>();
}
